<template>
  <section v-if="visibleRows.length" class="quiz-leaderboard">
    <h1>{{ heading }}</h1>
    <table>
      <thead class="sr-only">
        <tr>
          <th>Rank</th>
          <th>Name</th>
          <th>Score</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(player, index) in visibleRows" :key="index">
          <td class="rank">
            <strong>{{ index + 1 }}.</strong>
          </td>
          <td class="name">{{ player.username }}</td>
          <td class="score">{{ player.score }}</td>
        </tr>
      </tbody>
    </table>
    <a class="slate-link" v-if="rows.length > INITIAL_LENGTH" @click="toggle">{{
      expanded ? "View Less" : "View All"
    }}</a>
  </section>
  <h1 v-else>
    {{ heading }} leaderboard will display here after they take the quiz.
  </h1>
</template>

<script>
const INITIAL_LENGTH = 10;
export default {
  name: "Leaderboard",
  props: {
    heading: { type: String, required: true },
    rows: { type: Array, required: true },
  },
  data() {
    return {
      INITIAL_LENGTH,
      expanded: false,
    };
  },
  computed: {
    visibleRows() {
      return this.expanded ? this.rows : this.rows.slice(0, INITIAL_LENGTH);
    },
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped lang="css">
section {
  margin-bottom: 3.4em;
}

h1 {
  font-size: 1em;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

tr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6em;
}

tr:nth-child(odd) {
  background-color: rgba(225, 205, 214, 0.25);
  border-radius: 2px;
}

td.rank {
  flex: 0 0 1.5em;
}

td.name {
  flex: 1 0 auto;
  margin: 0 1.2em;
}

td.score {
  flex: 0 0 3em;
  text-align: right;
}

a {
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  border-width: 4px;
  font-size: 0.8em;
}
</style>
